/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import AsgardeoRuntimeError from '../errors/AsgardeoRuntimeError';
import {ApplicationNativeAuthenticationAuthenticatorExtendedParamType} from '../models/application-native-authentication';
import {FieldType} from '../models/field';

const resolveFieldName = (field: any): string => {
  if (field.param) {
    return field.param;
  }

  throw new AsgardeoRuntimeError(
    'Field name is not supported: ',
    'resolveFieldName-Invalid-001',
    'javascript',
    'The provided field name is not supported. Please check the field configuration.',
  );
};

export default resolveFieldName;
